import React, { useEffect, useMemo, useState } from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    AspectRatio as SizeIcon,
} from "@material-ui/icons";
import DataTable from "../../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../../components/confirm-modal-content";
import installmentService from "../../../../services/installment.service";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function FormQuestionsPage(props) {
    const { data, extra, onRefresh } = props

    const [questions, setQuestions] = useState([]);

    const deleteItem = (item) => {
        return installmentService.removeInstallmentQuestion(data.id, item.id);
    };
    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "عنوان",
                mainField: false,
            },
            {
                field: "typeOfAnswerText",
                title: "نوع پاسخ",
            },
        ],
        []
    );

    const setData = async () => {

        let form = [];
        try{
            form = JSON.parse(data?.form || "[]") 
        } catch(err){
            form = []
        }

        const items = form.map(item => ({
            ...item,
            selectOptions: item?.selectOptions ? JSON.parse(item?.selectOptions).map(it => ({selectOption: it})) : [],
            typeOfAnswerText: (() => {
                switch(item.typeOfAnswer){
                    case "string":
                        return "پاسخ کوتاه";
                    case "text":
                        return "متن بلند";
                    case "number":
                        return "عدد";
                    case "select":
                        return "انتخابی";
                }
            })()
        }))

        setQuestions(items);
    };

    useEffect(() => {
        setData();
    }, [data.form]);

    return (
        <div className="p-3">
            <DataTable
                order={{order: "ASC", orderBy: "order"}}
                headCells={headerCells}
                data={questions}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (p) => <FormModalContent {...p} parent={data} extra={extra} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد",
                        modalContent: (p) => (
                            <FormModalContent {...p} parent={data} extra={extra} />
                        ),
                    },
                ]}
                searchKeys={defaultKeys}
                title={`سوالهای بخش  "${data.title}"`}
            />
        </div>
    );
}
